export default __webpack_public_path__ + "27ad99da60c7f2993fd6a0d3c912a79d.png";